enum ActionTypes {
    SAVE_USER_TOKEN = "SAVE_USER_TOKEN",
    SAVE_AZURE_CREDS = "SAVE_AZURE_CREDS",
    LOGOUT_ACTION = "LOGOUT_ACTION",
    SAVE_AUTH_CREDENTIALS = "SAVE_AUTH_CREDENTIALS",
    SET_AUTHENTICATING = "SET_AUTHENTICATING",
}

export default ActionTypes;
